export async function loadProtomapsLeaflet() {
  if (window.protomapsL?.leafletLayer) {
    return Promise.resolve(window.protomapsL);
  }

  return new Promise((resolve, reject) => {
    const existingScript = document.querySelector(
      'script[data-protomaps-leaflet="true"]'
    );

    if (existingScript) {
      existingScript.addEventListener('load', () =>
        resolve(window.protomapsL)
      );
      existingScript.addEventListener('error', () =>
        reject(new Error('Failed to load Protomaps Leaflet script'))
      );
      return;
    }

    const script = document.createElement('script');
    // public/ is copied to /assets/ by CopyWebpackPlugin (see runtime.js,
    // referenced as /assets/runtime.js), so the vendored bundle lives there.
    script.src = '/assets/protomaps-leaflet.js';
    script.defer = true;
    script.dataset.protomapsLeaflet = 'true';
    script.onload = () => resolve(window.protomapsL);
    script.onerror = () =>
      reject(new Error('Failed to load Protomaps Leaflet script'));
    document.head.appendChild(script);
  });
}
